<div #box class="isolate grid size-full grid-flow-col items-center justify-around select-none">
  @for (c of clouds(); track $index) {
    <div class="relative">
      <img
        [src]="c.src"
        class="floaty pointer-events-none absolute size-16 -translate-x-[50%] -translate-y-[50%]"
        alt=""
        style="max-width: unset; max-height: unset"
        [style.animation-delay.ms]="-(clouds().length - ($index % 2 === 0 ? $index : clouds().length + $index)) * stagger()"
        [style]="{
          '--target': targets()[$index],
        }"
        (animationstart)="chooseNextPosition($index)"
        (animationiteration)="chooseNextPosition($index)"
      />
    </div>
  }
</div>
